/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Items_Tooltip_Internalnamespace1Inputs */

const id_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace internal Epic Games`)
};

const ms_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace dalaman Epic Games`)
};

const da_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games internt namespace`)
};

const de_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games interner Namespace`)
};

const en_us2_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games internal namespace`)
};

const es_es2_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace interno de Epic Games`)
};

const es_mx2_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace interno de Epic Games`)
};

const fil_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal na namespace ng Epic Games`)
};

const fr_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace interne d'Epic Games`)
};

const it_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace interno Epic Games`)
};

const hu_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games belső namespace`)
};

const nl_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interne namespace van Epic Games`)
};

const no_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games intern namespace`)
};

const pl_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wewnętrzny namespace Epic Games`)
};

const pt_br2_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace interno da Epic Games`)
};

const pt_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace interno da Epic Games`)
};

const ro_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace intern Epic Games`)
};

const fi_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Gamesin sisäinen namespace`)
};

const sv_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internt namespace för Epic Games`)
};

const vi_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace nội bộ của Epic Games`)
};

const tr_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games dahili ad alanı`)
};

const cs_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interní namespace Epic Games`)
};

const bg_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вътрешно Namespace на Epic Games`)
};

const ru_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Внутреннее пространство имён Epic Games`)
};

const uk_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Внутрішній Namespace Epic Games`)
};

const ar_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace داخلي لـ Epic Games`)
};

const hi_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games आंतरिक नेमस्पेस`)
};

const th_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace ภายในของ Epic Games`)
};

const ja_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games 内部 Namespace`)
};

const zh_cn2_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic游戏内部命名空间`)
};

const zh_hant1_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic遊戲內部命名空間`)
};

const ko_items_tooltip_internalnamespace1 = /** @type {(inputs: Items_Tooltip_Internalnamespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games 내부 Namespace`)
};

/**
* | output |
* | --- |
* | "Epic Games internal namespace" |
*
* @param {Items_Tooltip_Internalnamespace1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const items_tooltip_internalnamespace1 = /** @type {((inputs?: Items_Tooltip_Internalnamespace1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Items_Tooltip_Internalnamespace1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_items_tooltip_internalnamespace1(inputs)
	if (locale === "ms") return ms_items_tooltip_internalnamespace1(inputs)
	if (locale === "da") return da_items_tooltip_internalnamespace1(inputs)
	if (locale === "de") return de_items_tooltip_internalnamespace1(inputs)
	if (locale === "en-US") return en_us2_items_tooltip_internalnamespace1(inputs)
	if (locale === "es-ES") return es_es2_items_tooltip_internalnamespace1(inputs)
	if (locale === "es-MX") return es_mx2_items_tooltip_internalnamespace1(inputs)
	if (locale === "fil") return fil_items_tooltip_internalnamespace1(inputs)
	if (locale === "fr") return fr_items_tooltip_internalnamespace1(inputs)
	if (locale === "it") return it_items_tooltip_internalnamespace1(inputs)
	if (locale === "hu") return hu_items_tooltip_internalnamespace1(inputs)
	if (locale === "nl") return nl_items_tooltip_internalnamespace1(inputs)
	if (locale === "no") return no_items_tooltip_internalnamespace1(inputs)
	if (locale === "pl") return pl_items_tooltip_internalnamespace1(inputs)
	if (locale === "pt-BR") return pt_br2_items_tooltip_internalnamespace1(inputs)
	if (locale === "pt") return pt_items_tooltip_internalnamespace1(inputs)
	if (locale === "ro") return ro_items_tooltip_internalnamespace1(inputs)
	if (locale === "fi") return fi_items_tooltip_internalnamespace1(inputs)
	if (locale === "sv") return sv_items_tooltip_internalnamespace1(inputs)
	if (locale === "vi") return vi_items_tooltip_internalnamespace1(inputs)
	if (locale === "tr") return tr_items_tooltip_internalnamespace1(inputs)
	if (locale === "cs") return cs_items_tooltip_internalnamespace1(inputs)
	if (locale === "bg") return bg_items_tooltip_internalnamespace1(inputs)
	if (locale === "ru") return ru_items_tooltip_internalnamespace1(inputs)
	if (locale === "uk") return uk_items_tooltip_internalnamespace1(inputs)
	if (locale === "ar") return ar_items_tooltip_internalnamespace1(inputs)
	if (locale === "hi") return hi_items_tooltip_internalnamespace1(inputs)
	if (locale === "th") return th_items_tooltip_internalnamespace1(inputs)
	if (locale === "ja") return ja_items_tooltip_internalnamespace1(inputs)
	if (locale === "zh-CN") return zh_cn2_items_tooltip_internalnamespace1(inputs)
	if (locale === "zh-Hant") return zh_hant1_items_tooltip_internalnamespace1(inputs)
	return ko_items_tooltip_internalnamespace1(inputs)
});
export { items_tooltip_internalnamespace1 as "items.tooltip.internalNamespace" }